import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, ShieldCheck, Zap } from "lucide-react";
import { LIVE_ACCOUNT_URL } from "../lib/api";
import { fadeVariants } from "../lib/motion";

const badgeEnter = fadeVariants({ y: 18, duration: 0.6 });
const headingEnter = fadeVariants({ y: 24, duration: 0.7, delay: 0.05 });
const copyEnter = fadeVariants({ y: 24, duration: 0.7, delay: 0.15 });
const ctaEnter = fadeVariants({ y: 24, duration: 0.7, delay: 0.25 });
const trustEnter = fadeVariants({ duration: 0.8, delay: 0.4 });

function HeroBadge() {
    return (
        <motion.div
            variants={badgeEnter}
            initial="hidden"
            animate="visible"
            className="inline-flex items-center gap-2 rounded-full border border-[#A6E3DC]/30 bg-[#A6E3DC]/5 px-4 py-1.5 mb-7"
        >
            <span className="w-1.5 h-1.5 rounded-full bg-[#00FFC2] animate-pulse" />
            <span className="text-xs font-semibold tracking-wide text-[#A6E3DC]">
                MT5 ENGINE · ANJOUAN COMOROS REGULATED · LIVE NOW
            </span>
        </motion.div>
    );
}

function HeroHeading() {
    return (
        <>
            <motion.h1
                variants={headingEnter}
                initial="hidden"
                animate="visible"
                className="text-4xl sm:text-5xl lg:text-7xl font-extrabold tracking-tight text-white leading-[1.02]"
            >
                Trade global markets
                <br />
                with <span className="text-[#A6E3DC]">precision</span>.
            </motion.h1>
            <motion.p
                variants={copyEnter}
                initial="hidden"
                animate="visible"
                className="text-slate-300/90 text-lg lg:text-xl mt-7 max-w-xl leading-relaxed"
            >
                Forex and crypto CFDs on the MetaTrader 5 engine. Tight
                spreads, fast execution, and a regulated home for serious
                traders.
            </motion.p>
        </>
    );
}

function HeroCTAs() {
    return (
        <motion.div
            variants={ctaEnter}
            initial="hidden"
            animate="visible"
            className="flex flex-wrap items-center gap-4 mt-10"
        >
            <a
                data-testid="hero-cta-open-live"
                href={LIVE_ACCOUNT_URL}
                target="_blank"
                rel="noreferrer"
                className="btn-primary"
            >
                Open Live Account <ArrowUpRight size={18} />
            </a>
            <a
                data-testid="hero-cta-explore-mt5"
                href="/platform"
                className="btn-secondary"
            >
                Explore MT5
            </a>
        </motion.div>
    );
}

function HeroTrustRow() {
    return (
        <motion.div
            variants={trustEnter}
            initial="hidden"
            animate="visible"
            className="flex flex-wrap items-center gap-x-8 gap-y-3 mt-12 text-sm text-slate-400"
        >
            <div className="flex items-center gap-2">
                <ShieldCheck size={16} className="text-[#A6E3DC]" /> Anjouan,
                Comoros licensed
            </div>
            <div className="flex items-center gap-2">
                <Zap size={16} className="text-[#A6E3DC]" /> ~10ms execution
            </div>
            <div className="flex items-center gap-2">
                <span className="font-mono text-[#A6E3DC]">100+</span> Forex &
                Crypto pairs
            </div>
        </motion.div>
    );
}

export default function HeroCopy() {
    return (
        <div className="lg:col-span-7">
            <HeroBadge />
            <HeroHeading />
            <HeroCTAs />
            <HeroTrustRow />
        </div>
    );
}
